import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.chat');
import { OnInit } from "@angular/core";
import { ElementRef, ViewChild } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

const DETAILS: any = {
    'colosseum': {
        title: "로마 콜로세움",
        glb: 'colosseum.glb',
        images: ['colosseum-1.jpeg', 'colosseum-2.jpeg']
    },
    'baekje': {
        title: "백제",
        glb: 'baekje.glb',
        images: ['baekje-1.jpeg']
    },
    'bagan': {
        title: "바간",
        glb: 'bagan.glb',
        images: ['bagan-1.jpeg', 'bagan-2.jpeg']
    },
    'angkorwat': {
        title: "앙코르와트",
        glb: 'angkorwat.glb',
        images: ['angkorwat-1.jpeg']
    },
    'qin': {
        title: "진시황 병마용",
        glb: 'qin.glb',
        images: ['qin-1.jpeg']
    },
    'amitabul': {
        title: "기축명아미타불비상",
        glb: 'amitabul.glb',
        images: ['amitabul-1.jpeg']
    },
    'digital': {
        title: "디지털 헤리티지",
        glb: 'digital.glb',
        images: ['digital-1.jpeg']
    }
};

const ITEMS: any = [
    {
        title: '세계 유산 탐험',
        child: [
            {
                target: 'colosseum',
                title: '로마 콜로세움',
                desc: '서기 80년에 지어진 고대 로마의 원형경기장으로, 검투사들의 전투와 공개 처형이 벌어졌던 역사적 장소입니다.',
                src: 'colosseum-1.jpeg'
            },
            {
                target: 'baekje',
                title: '백제',
                desc: '한반도의 고대 삼국 중 하나로, 찬란한 불교 문화와 국제적 교류의 중심이었습니다.',
                src: 'baekje-1.jpeg'
            },
            {
                target: 'bagan',
                title: '바간',
                desc: '미얀마 중부 평야에 위치한 고대 불교 유적지로, 수천 개의 사원이 넓게 펼쳐져 있습니다.',
                src: 'bagan-1.jpeg'
            },
            {
                target: 'angkorwat',
                title: '앙코르와트',
                desc: '캄보디아 크메르 제국의 대표적 사원으로, 힌두교와 불교가 혼합된 건축 양식을 보여줍니다.',
                src: 'angkorwat-1.jpeg'
            },
            {
                target: 'qin',
                title: '진시황 병마용',
                desc: '중국 최초의 통일 황제인 진시황의 무덤을 지키는 수천 개의 테라코타 병사 조각상입니다.',
                src: 'qin-1.jpeg'
            },
            {
                target: 'amitabul',
                title: '기축명아미타불비상',
                desc: '백제의 불상 유물 중 하나로, 미소 짓는 얼굴과 섬세한 조각이 특징입니다.',
                src: 'amitabul-1.jpeg'
            },
            {
                target: 'digital',
                title: '디지털 헤리티지',
                desc: '세계 문화유산을 디지털로 복원하고 전시하는 최신 기술 기반의 문화유산 접근 방식입니다.',
                src: 'digital-1.jpeg'
            }
        ]
    }
];

@Component({
    selector: 'wiz-page-chat',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.chat/view.scss */
.video-container-portrait {
  width: auto;
  height: 100vh;
  max-height: 100%;
  overflow: hidden;
  position: relative;
  aspect-ratio: 54/86;
}

.video-container-landscape {
  width: auto;
  height: 100vh;
  max-height: 100%;
  overflow: hidden;
  position: relative;
  aspect-ratio: 86/54;
}

video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scaleX(-1);
  height: 100%;
  object-fit: cover;
}`],
})
export class PageChatComponent implements OnInit {
    @ViewChild('viewer') viewer: ElementRef;

    public view: any = 'list';

    public items: any = ITEMS;
    public selected: any;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public async home() {
        this.view = 'list';
        this.selected = null;
        await this.service.render();
    }

    public async clickItem(item) {
        let target = DETAILS[item.target];
        this.view = 'item';
        this.selected = target;
        await this.service.render();

        const opts = {
            grid: false,
            trackball: false,
            background: 'rgba(232, 232, 232)'
            // background: 'rgb(255, 255, 255)'
        }
    }

    public chatbotUrl(selected) {
        return 'https://llm.baekje.seasonai.net/?page=' + encodeURIComponent(selected.title);
    }

}

export default PageChatComponent;